import { render } from "./Pos.vue?vue&type=template&id=33da74fb&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=33da74fb&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/BEELIA/mi-stock-beelia-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33da74fb"]])

export default __exports__